import { render, staticRenderFns } from "./CrSoroushDestination.vue?vue&type=template&id=58e88f6c&"
import script from "./CrSoroushDestination.vue?vue&type=script&lang=js&"
export * from "./CrSoroushDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports